import React, {FC} from "react";
import {Captcha} from "./Captcha";
import {useAuth} from "../auth/AuthContext";
import {useNavigate} from "react-router";
import {CaptchaStore} from "./store";
import {doInitAccount} from "../../accounts-api/init-account";
const Humans = React.lazy(() => import("./HumansAreComing"));


export const CaptchaRetry: FC = () => {
  const navigate = useNavigate();
  const {user, loading, clearError} = useAuth();
  if (loading) {
    return null;
  }

  const initAccount = async (token: string) => {
    if (!user) {
      return;
    }
    CaptchaStore.set(token);
    try {
      await doInitAccount(user);
      clearError();
      navigate("/authenticated");
    } catch (err) {
      console.error("captcha retry failed", err);
    }
  };
  
  return <div className="flex flex-col">
    <div className="mb-5">
      <Humans />
    </div>
    <Captcha tokenCallback={initAccount} visible={true} mode={"challenge"}/>
  </div>
}
